import React, { useContext, useEffect, useState } from "react";
import { StyleContext } from "../providers/StyleContextProvider";
import { RecruiterMenu } from "../components/Shared/RecruiterMenu";
import { Button } from "../components/Shared/Buttons/Button";
import { ReactComponent as Plus } from '../assets/svg/plus.svg';
import { ReactComponent as SearchIcon } from '../assets/svg/search.svg';
// import { ReactComponent as DropDownIcon } from '../assets/svg/drop_down.svg';
import { useMediaQuery } from "react-responsive";
import { SingleSelect } from "../components/Shared/SingleSelect";
import { SelectInputs } from "../models/SelectInputs";
import { CheckboxInput } from "../components/Shared/Inputs/CheckboxInput";
import { getCandidateCVUrlByRecruiter } from "../helpers/Common";
import { ReactComponent as ExternalLink } from '../assets/svg/external-link.svg';
import { Pagination } from "../components/Shared/Pagination";
import { PopUpWindow } from '../components/Shared/PopUpWindow';
import { CandidatesSearchCriteria } from "../models/CandidatesSearchCriteria";
import { LoggedRecruiter } from "../models/LoggedRecruiter";
import { AuthContext } from "../providers/AuthContextProvider";
import { getCandidateProfileDetails, getCandidatesByOrg } from "../services/RecruiterService";
import { LazyProfileImage } from "../components/Shared/LazyProfileImage";
import { Candidate } from "../models/Candidate";
import useErrorPage from "../hooks/useErrorPage";
import { FeedbackCard } from "../components/Shared/FeedbackCard";
import { useAlert } from "../hooks/useAlert";
import { LocationSelect } from "../components/Shared/LocationSelect";
import { SectorSelect } from "../components/Shared/SectorSelect";
import { DocumentViewer } from "../components/Shared/DocumentViewer";
import { Footer } from "../components/Shared/Footer";
import { CandidateListLoader } from "../components/Loaders/CandidateListLoader";
import { ReactComponent as Search } from '../assets/svg/search.svg';
import { ProfileEntrance } from "../components/Home/ProfileEntrance";
import { AddCandidate } from "../components/CandidatePool/AddCandidate";
import { TabItem } from "../models/TabItem";
import { ProfileTab } from "../components/CandidatePool/ProfileTab";
import { JobApplication } from "../models/JobApplication";
import { InfoTab } from "../components/CandidatePool/InfoTab";
import { JobApplicationsTab } from "../components/CandidatePool/JobApplicationsTab";
import { CVTab } from "../components/CandidatePool/CVTab";
import { TabPanel } from "../components/CandidatePool/TabPanel";
import { Sector } from "../models/Sector";
import { CandidateTabPanelLoader } from "../components/Loaders/CandidateTabPanelLoader";
import { EmailToCandidate } from "../components/Shared/EmailToCandidate";
import { UserType } from "../enums/UserType";
import { RemoveScroll } from 'react-remove-scroll';

interface ProfileDetails {
    candidate: Candidate;
    jobApplications: JobApplication[];
    preferredSectors: Sector[];
    cvFileName: string;
}

export const CandidatePoolPage: React.FC = () => {
    const styleContext = useContext(StyleContext);
    const styles = styleContext.getComponentStyle("candidatePoolPage");
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const [isSubOrganization, setIsSubOrganization] = useState<boolean>(false);    
    const [sortBy, setSortBy] = useState<string>("Forename ASC");
    const [pageSize, setPageSize] = useState<number>(20);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>();
    const [candidates, setCandidates] = useState<Candidate[]>([]);
    const [recordCount, setRecordCount] = useState<number>(0);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [selections, setSelections] = useState<Record<number, boolean>>({});    
    const [hoveredIndex, setHoveredIndex] = useState<number>(-1);
    const [keyword, setKeyword] = useState<string>("");  
    const [email, setEmail] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [jobTitle, setJobTitle] = useState<string>("");
    const [sectorIds, setSectorIds] = useState<string>("");
    const [locationIds, setLocationIds] = useState<string>("");
    const [lastUpdatedFrom, setLastUpdatedFrom] = useState<string>(""); 
    const [lastUpdatedTo, setLastUpdatedTo] = useState<string>("");
    const [openCVPopup, setOpenCVPopup] = useState<boolean>(false);
    // const [pending, setPending] = useState<boolean>(false);
    const [findCandidate, setFindCandidate] = useState<boolean>(true);
    const [cvPreviewCandidate, setCVPreviewCandidate] = useState<Candidate | null>(null);
    const [resetState, setResetState] = useState<boolean>(false);
    // const [topPickJobHovered, setTopPickJobHovered] = useState<boolean>(false);
    // const [cardPickJobHovered, setCardPickJobHovered] = useState<boolean>(false);
    const [hasSelected, setHasSelected] = useState<boolean>(false);    
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [openAddCandidateDialog, setOpenAddCandidateDialog] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [toErrorPage] = useErrorPage();
    const { Alert, openAlert } = useAlert();
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const [displayTabs, setDisplayTabs] = useState<boolean>(false);
    const [tabItems, setTabItems] = useState<TabItem[]>([]);
    const [profileDetails, setProfileDetails] = useState<ProfileDetails | null>(null);
    const [profileLoading, setProfileLoading] = useState<boolean>(true);
    const [recipientEmails, setRecipientEmails] = useState<string[]>([]);
    const [candidateIds, setCandidateIds] = useState<string>("");
    const [showEmailComponent, setShowEmailComponent] = useState<boolean>(false);
    const MAX_RECIPIENTS = 25;

    const sortBySelectInputs: SelectInputs = {
        default: "A-Z",
        options: [
            {"value": "LastUpdatedDate DESC", "option": "Recently added"},
            {"value": "LastUpdatedDate ASC", "option": "Formerly added"},
            {"value": "Forename ASC", "option": "A-Z"},
            {"value": "Forename DESC", "option": "Z-A"}
        ]
    }

    const perPageSelectInputs: SelectInputs = {
        default: pageSize.toString(),
        options: [
            {"value": 15, "option": "15"},
            {"value": 20, "option": "20"},
            {"value": 30, "option": "30"},
            {"value": 60, "option": "60"}
        ]
    }

    useEffect(() => {
        candidatesByOrg();
    }, [pageSize, sortBy, keyword]);

    useEffect(() => {
        if (resetState) {
            candidatesByOrg();
            setResetState(false);
        }
    }, [resetState]);

    const handlePageSize = (selectedPageSize: number) => {
        setPage(1);
        setPageSize(selectedPageSize);
    }

    const handlePagination = (selectedPage: number) => {
        setPage(selectedPage);
        window.scrollTo({top: 0, behavior: 'smooth'});
        candidatesByOrg(selectedPage);
    }

    const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        const newSelections: Record<number, boolean> = {};
        candidates.forEach(candidate => {
            newSelections[candidate.candidateId] = isChecked;
        });
        setSelections(newSelections);
        setHasSelected(isChecked);        
        setSelectAll(isChecked);
    };

    const handleSelectOneChange = (candidateId: number) => {
        const newSelections = {
            ...selections,
            [candidateId]: !selections[candidateId]
        };
        setSelections(newSelections);
        const anySelected = Object.values(newSelections).some(selected => selected);
        setHasSelected(anySelected);
        const allSelected = candidates.length === Object.values(newSelections).filter(Boolean).length;
        setSelectAll(allSelected);
    };

    const handleSearchSubmit = (searchTerm: string) => {
        setPage(1);
        setKeyword(searchTerm);     
    }

    const openAddCandidate = () => {
        setOpenAddCandidateDialog(true);
    }

    const handleAddCandidateSuccess = (message: string) => {
        openAlert("success", message);
        candidatesByOrg();
    }

    const handleAddCandidateError = (message: string) => {
        openAlert("error", message);
    }

    const onSubOrganizationChange = (status: boolean) => {
        setIsSubOrganization(status);
    };

    const showCandidateCV = (e: React.MouseEvent, candidateId: number) => {
        e.stopPropagation();
        const candidate = candidates.find(c => c.candidateId === candidateId);
        if (candidate && candidate.cvTranslationText) {
            setCVPreviewCandidate({ candidateId: candidateId, cvTranslationText: candidate.cvTranslationText } as any);
            setOpenCVPopup(true);
        }
    }
    
    const handleFilterSearch = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setPage(1);
        candidatesByOrg(1);
    }

    const clearSearch = () => {
        setName("");
        setEmail("");
        setJobTitle("");
        setSectorIds("");
        setLocationIds("");
        setLastUpdatedFrom("");
        setLastUpdatedTo("");                
        setPage(1);
        setResetState(true);
    }

    const handleCandidateClick = (candidate : Candidate) => {
        setProfileDetails(null); 
        setDisplayTabs(true);
        setProfileLoading(true);
        getCandidateProfile(candidate.candidateId);
    }

    const closePopUp = () => {
        setDisplayTabs(false);
    }

    const openEmailComponent = () => {
        const selectedCount = Object.values(selections).filter(selected => selected).length;
        if (selectedCount > MAX_RECIPIENTS) {
            openAlert("error", `You can select a maximum of ${MAX_RECIPIENTS} recipients at once.`);
            return;
        }
        const selectedCandidates = candidates.filter(c => selections[c.candidateId]).filter(c => c.email);
        const selectedEmails = selectedCandidates.map(c => c.email);
        const selectedCandidateIds = selectedCandidates.map(c => c.candidateId.toString());
        setRecipientEmails(selectedEmails);
        setCandidateIds(selectedCandidateIds.join(','));
        setShowEmailComponent(true);
    }

    const closeEmailComponent = () => {
        setShowEmailComponent(false);
    }

    async function getCandidateProfile(candidateId: number) {
        await getCandidateProfileDetails(candidateId, recruiter!.recruiterId, recruiter!.token)
        .then((response: ProfileDetails) => {
            const applicantCvText = candidates.find(a => a.candidateId === response?.candidate.candidateId)?.cvTranslationText;
            const hasInfoContent =
                !!response.candidate?.linkedInUrl ||
                (response.preferredSectors && response.preferredSectors.length > 0) ||
                !!response.candidate?.additionalQualifications;
            const newTabItems = [
                {label: "Profile", value: "profile", component: <ProfileTab selectedCandidate={response.candidate} />},
                ...(hasInfoContent ? [{label: "Info", value: "info", component: <InfoTab selectedCandidate={response.candidate} preferredSectors={response.preferredSectors} />}] : []),
                {label: "Job Applications", value: "jobapplications", component: <JobApplicationsTab jobApplications={response.jobApplications} />},
                {label: "CV", value: "cv", component: <CVTab cvTranslationText={applicantCvText!} cvFileName={response.cvFileName} recruiterId={recruiter!.recruiterId} token={recruiter!.token} />}
            ];
            setTabItems(newTabItems);
            setProfileDetails(response);
            setProfileLoading(false);
        })
        .catch((error) => {
            toErrorPage(error, UserType.Recruiter);
        });
    }

    async function candidatesByOrg(currentPage?: number) {
        setLoading(true);
        if(!currentPage)
            currentPage = page;

        let searchCriteria: CandidatesSearchCriteria = {
            page: currentPage,
            pageSize: pageSize,
            recruiterId: recruiter!.recruiterId,
            organizationIds: recruiter!.organizationId.toString(),
            sectorIds: sectorIds,
            locationIds: locationIds,
            name: name,
            jobTitle: jobTitle,
            email: email,
            keyword: keyword,
            lastUpdatedFrom: lastUpdatedFrom,
            lastUpdatedTo: lastUpdatedTo,
            sortVal: sortBy // (Forename ASC)
        }
        await getCandidatesByOrg(searchCriteria, recruiter!.token)
        .then((candidates: Candidate[]) => {
            setCandidates(candidates);
            if(candidates.length > 0) {
                const totalRecords = candidates[0].totalRecordsCount ?? 0;
                setRecordCount(totalRecords);
                let totalPageCount = Math.ceil(totalRecords / pageSize);
                setTotalPages(totalPageCount);
            } else {
                setRecordCount(0)
                setTotalPages(1);
            }
            setLoading(false);
        })
        .catch((error) => {
            toErrorPage(error, UserType.Recruiter);
        });
    }

    return (
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.leftWrapper}>
                    <RecruiterMenu isSubOrganization={onSubOrganizationChange}>
                        {(!isSubOrganization && !showEmailComponent) && <Button style={styles.newCandidate} onClick={openAddCandidate}>
                            {"Add a new candidate"}
                            <span style={styles.newCandidate.iconWrapper}><Plus style={styles.newCandidate.icon}/></span>
                        </Button>}
                        {(isMobile && showEmailComponent) && <p style={styles.emailContainer.title}>{"Send a new email"}</p>} 
                    </RecruiterMenu>
                </div>
                {(isMobile && showEmailComponent) ? (
                    <EmailToCandidate 
                        recipientEmails={recipientEmails} 
                        candidateIds={candidateIds}
                        recruiterId={recruiter!.recruiterId}
                        token={recruiter!.token}
                        style={styles.emailContainer} 
                        onClose={closeEmailComponent} 
                        onParentAlert={openAlert}
                    />
                ) : (isMobile && displayTabs) ? (
                        profileLoading ? (
                            <CandidateTabPanelLoader />
                        ) : (
                            <TabPanel 
                                selectedCandidate={profileDetails?.candidate!} 
                                style={styles.popUpContainer} 
                                tabItems={tabItems} 
                                onClose={closePopUp}
                            />
                        )
                    ) : (
                        <div style={styles.rightWrapper}>
                            <div style={styles.searchWrapper}>
                                <div style={styles.searchBar}>
                                    <input 
                                        style={styles.searchBar.input} 
                                        placeholder={"Search Candidate"} 
                                        value={searchTerm} 
                                        onChange={(e) => setSearchTerm(e.target.value)} 
                                        onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit(searchTerm)}
                                    />
                                    <Search style={styles.searchBar.icon} onClick={() => handleSearchSubmit(searchTerm)}/>
                                </div>
                                <div style={styles.profileWrapper}><ProfileEntrance recruiter={recruiter} /></div>
                            </div>
                            <div style={styles.status}>
                                <div style={styles.status.title}>{"Candidate Pool"}</div>
                                <div style={styles.status.tag}>
                                    <div 
                                        style={{...styles.status.find, ...(findCandidate && styles.status.selected)}} 
                                        onClick={() => {
                                            setFindCandidate(true); 
                                            // setPending(false)
                                        }}
                                    >
                                        {"Find Candidates"}
                                    </div>
                                    {/* <div 
                                        style={{...styles.status.pending, ...(pending && styles.status.selected)}} 
                                        onClick={() => {
                                            setPending(true); 
                                            setFindCandidate(false)
                                        }}
                                    >
                                        {"Pending ()"}
                                    </div> */}
                                </div>
                                <Button style={styles.status.addNew} onClick={openAddCandidate}>
                                    {"ADD NEW"}
                                    <Plus style={styles.status.addNewIcon}/>
                                </Button>
                                {isMobile && <form style={styles.search} onSubmit={(e) => { e.preventDefault(); handleSearchSubmit(searchTerm); }}>
                                    <input 
                                        type="text" 
                                        style={{...styles.search, ...styles.search.input}} 
                                        placeholder={"Search Candidate"} 
                                        value={searchTerm} 
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <div style={styles.search.iconWrapper}>
                                        <SearchIcon style={styles.search.icon} onClick={() => handleSearchSubmit(searchTerm)}/>
                                    </div>
                                </form>}
                            </div>
                            {!isMobile && <div style={styles.count}>{recordCount + " Candidates"}</div>}
                            <div style={styles.findCandidate}>
                                <div style={styles.findCandidate.title}>{"Find Candidates"}</div>
                                <div style={styles.findCandidate.filterSection}>
                                    <div>
                                        <div style={styles.findCandidate.firstRow}>
                                            <div style={styles.findCandidate.nameWrapper}>
                                                <div style={styles.findCandidate.text}>{"Name"}</div>
                                                <div style={styles.findCandidate.largeDropdown}>
                                                    <input type="text" style={styles.findCandidate.largeInput} placeholder={"Enter Name"} value={name} onChange={(e) => setName(e.target.value)}/>
                                                </div>
                                            </div>
                                            <div style={styles.findCandidate.emailWrapper}>
                                                <div style={styles.findCandidate.text}>{"Email"}</div>
                                                <div style={styles.findCandidate.largeDropdown}>
                                                    <input type="text" style={styles.findCandidate.largeInput} placeholder={"Enter Email"} value={email} onChange={(e) => setEmail(e.target.value)}/>
                                                </div>
                                            </div>
                                            <div style={styles.findCandidate.jobTitleWrapper}>
                                                <div style={styles.findCandidate.text}>{"Job Title"}</div>
                                                <div style={styles.findCandidate.largeDropdown}>
                                                    <input type="text" style={styles.findCandidate.largeInput} placeholder={"Enter Job Title"} value={jobTitle} onChange={(e) => setJobTitle(e.target.value)}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={styles.findCandidate.secondRow}>
                                            <div style={styles.findCandidate.sector}>
                                                <div style={styles.findCandidate.text}>{"Sector"}</div>
                                                <SectorSelect styles={styles.select} default="Choose a Sector" selectedIds={sectorIds} getSelectedIds={setSectorIds} setSelectHovered={() => {}}/>
                                            </div>
                                            <div style={styles.findCandidate.location}>
                                                <div style={styles.findCandidate.text}>{"Location"}</div>
                                                <LocationSelect styles={styles.select} default={"Choose a Location"} selectedIds={locationIds} getSelectedIds={setLocationIds} setSelectHovered={() => {}}/>
                                            </div>
                                            <div>
                                                <div style={styles.findCandidate.text}>{"Last Updated"}</div>
                                                <div style={styles.findCandidate.dateWrapper}>
                                                    <div style={styles.findCandidate.row}>
                                                        <span style={styles.findCandidate.dateText}>{"From"}</span>                                     
                                                        <input
                                                            type="date"
                                                            id="fromDate"
                                                            name="downloadFromDate"
                                                            value={lastUpdatedFrom}  
                                                            onChange={(e) => setLastUpdatedFrom(e.target.value)}     
                                                            style={styles.findCandidate.dateInput}                                     
                                                        />                             
                                                    </div>
                                                    <div style={styles.findCandidate.row}>
                                                        <span style={styles.findCandidate.dateText}>{"To"}</span>                                     
                                                        <input
                                                            type="date"
                                                            id="toDate"
                                                            name="downloadToDate"
                                                            value={lastUpdatedTo} 
                                                            onChange={(e) => setLastUpdatedTo(e.target.value)}
                                                            style={styles.findCandidate.dateInput}                                        
                                                        />                           
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={styles.findCandidate.flexContainer}>
                                        <Button style={styles.findCandidate.reset} onClick={clearSearch}>{"RESET"}</Button>
                                        <Button style={styles.findCandidate.search} onClick={handleFilterSearch}>{"SEARCH"}</Button>
                                    </div>
                                </div>
                            </div>
                            <div style={styles.candidateSelection}>
                                <div style={styles.candidateSelection.titleWrapper}>
                                    <span style={styles.candidateSelection.title}>{"Candidates"}</span>
                                    {!loading && candidates.length > 0 && <div style={styles.candidateSelection.sortWrapper}>
                                        <SingleSelect styles={styles.candidateSelection.sortSelect} label={"Sort by"} selectInputs={sortBySelectInputs} getSelected={setSortBy} />
                                        {isMobile && <SingleSelect styles={styles.candidateSelection.perPageSelect} label={"Per Page"} selectInputs={perPageSelectInputs} getSelected={handlePageSize} />}
                                    </div>}
                                </div>
                                <div style={styles.candidateSelection.selectWrapper}>
                                    {isMobile && <div style={styles.candidateSelection.selectAllWrapper}> 
                                        {!loading && candidates.length > 0 && <CheckboxInput styles={styles.candidateSelection.checkBox} name="SelectAll" value={selectAll} handleChange={handleSelectAllChange}>
                                            <span style={styles.candidateSelection.selectLabel}>{"Select all"}</span>
                                        </CheckboxInput>}
                                        {hasSelected && <Button style={styles.candidateSelection.sendEmailButton} onClick={() => openEmailComponent()}>{"SEND EMAIL"}</Button>}
                                    </div>}
                                    {/* This feature needs to be implemented in the future */}
                                    {/* <div style={styles.candidateSelection.pickJob} 
                                        onMouseEnter={() => { setTopPickJobHovered(true); }}
                                        onMouseLeave={() => { setTopPickJobHovered(false); }}
                                        onClick={() => { setTopPickJobHovered(!topPickJobHovered); }}
                                    >
                                        <input type="text" style={styles.findCandidate.largeInput} placeholder={"Pick a Job"}/>
                                        <DropDownIcon style={{...styles.findCandidate.icon, ...(topPickJobHovered && styles.findCandidate.icon.hover)}} />
                                    </div>
                                    <Button style={styles.candidateSelection.requestButton}>{"REQUEST SELECTED"}</Button> */}
                                    {hasSelected && !isMobile && <Button style={styles.candidateSelection.sendEmailButton} onClick={() => openEmailComponent()}>{"SEND EMAIL"}</Button>}
                                </div>
                            </div>
                            {!isMobile && !loading && candidates.length > 0 && <CheckboxInput styles={styles.candidateSelection.checkBoxRow} name="SelectAll" value={selectAll} handleChange={handleSelectAllChange}>
                                <span style={styles.candidateSelection.selectLabel}>{"Select all"}</span>
                            </CheckboxInput>}
                            <div style={styles.candidateList}>
                                {loading ? <CandidateListLoader/> :
                                <>
                                    {candidates.length > 0 ? <>
                                        {candidates.map((candidate, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        ...styles.candidateCard,
                                                        ...(index + 1 !== hoveredIndex && styles.candidateCard.bottomBorder), 
                                                        ...(hoveredIndex === index && styles.candidateCard.hovered)
                                                    }}
                                                    onClick = {() => handleCandidateClick(candidate)}
                                                    onMouseEnter={() => setHoveredIndex(index)}
                                                    onMouseLeave={() => setHoveredIndex(-1)}
                                                >
                                                    <div onClick={(e) => e.stopPropagation()}>
                                                        <CheckboxInput styles={styles.candidateCard.checkBox} value={selections[candidate.candidateId] || false} handleChange={() => handleSelectOneChange(candidate.candidateId)}/>
                                                    </div>
                                                    <div style={styles.candidateCard.userProfile}>
                                                        <LazyProfileImage
                                                            candidateId={candidate.candidateId}                                                            
                                                            style={styles.candidateCard.userAvatar}
                                                        />
                                                        <div style={styles.candidateCard.details}>
                                                            <div style={styles.candidateCard.userInfo}>
                                                                <div style={styles.candidateCard.name}>{candidate.forename} {candidate.surname}</div>
                                                                <div style={styles.candidateCard.address}>{candidate.address1}</div>
                                                            </div>
                                                            <div style={styles.candidateCard.contactInfo}>
                                                                <div style={styles.candidateCard.text}>{"Contact"}</div>
                                                                <div style={{...styles.candidateCard.boldText, ...(styles.candidateCard.email)}}>{candidate.email}</div>
                                                                <div style={styles.candidateCard.boldText}>{candidate.mobileNumber}</div>
                                                            </div>
                                                            <div style={{...styles.candidateCard.jobInfo, ...(hoveredIndex === index && styles.candidateCard.jobInfo.hovered)}}>
                                                                <div style={styles.candidateCard.text}>{"Current Job"}</div>
                                                                <div style={{...styles.candidateCard.boldText, ...styles.candidateCard.boldText.recentJobTitle, ...(hoveredIndex === index && styles.candidateCard.boldText.hovered)}}>{candidate.recentJobTitle}</div>
                                                                <div style={styles.candidateCard.boldText}>{candidate.recentEmployer}</div>
                                                            </div>
                                                            {/* This feature needs to be implemented in the future */}
                                                            {/* {!isMobile && (hoveredIndex === index) && <div 
                                                                style={styles.candidateCard.pickJobWrapper} 
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div 
                                                                    style={styles.candidateCard.pickJob}
                                                                    onMouseEnter={() => setCardPickJobHovered(true) }
                                                                    onMouseLeave={() => setCardPickJobHovered(false) }
                                                                    onClick={() => setCardPickJobHovered(!cardPickJobHovered) }
                                                                >
                                                                    <input type="text" style={styles.candidateCard.input} placeholder={"Pick a Job"}/>
                                                                    <DropDownIcon style={{...styles.candidateCard.icon, ...(cardPickJobHovered && styles.findCandidate.icon.hover)}} />
                                                                </div>
                                                                <Button style={styles.candidateCard.request}>{"REQUEST"}</Button>
                                                            </div>} */}
                                                            <div style={styles.candidateCard.viewCvButton}>
                                                                <Button 
                                                                    style={styles.candidateCard.viewCv} 
                                                                    onClick={(e) => {showCandidateCV(e, candidate.candidateId)}}
                                                                >
                                                                    {"View CV"}
                                                                    <ExternalLink style={styles.candidateCard.viewCvIcon} />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* {isMobile && selections[candidate.candidateId] && (<div onClick={(e) => e.stopPropagation()}>
                                                        <div 
                                                            style={styles.candidateCard.pickJob} 
                                                            onMouseEnter={() => setCardPickJobHovered(true) }
                                                            onMouseLeave={() => setCardPickJobHovered(false) }
                                                            onClick={() => setCardPickJobHovered(!cardPickJobHovered) }
                                                        >
                                                            <input type="text" style={styles.candidateCard.input} placeholder={"Pick a Job"}/>
                                                            <DropDownIcon style={{...styles.candidateCard.icon, ...(cardPickJobHovered && styles.findCandidate.icon.hover)}} />
                                                        </div>
                                                        <Button style={styles.candidateCard.request}>{"REQUEST"}</Button>
                                                    </div>)} */}
                                                </div>
                                            )
                                        })}
                                    </> : 
                                    <FeedbackCard
                                        styles={styles.noCandidates}
                                        message={`There are no candidates available.`}
                                    />}
                                </>}
                            </div>
                            {candidates.length > 0 && <div style={styles.paginationWrapper}>
                                {!isMobile && <SingleSelect styles={styles.perPageSelect} label={"Posts Per Page"} selectInputs={perPageSelectInputs} getSelected={setPageSize} />}
                                {<Pagination page={page} totalPages={totalPages!} handlePagination={handlePagination} extendedStyles={styles.pagination} />}
                            </div>}
                        </div> 
                    )    
                } 
            </div>
            {openAddCandidateDialog && (
                <RemoveScroll>
                    <AddCandidate
                        open={openAddCandidateDialog}
                        onClose={() => setOpenAddCandidateDialog(false)}
                        onSuccess={handleAddCandidateSuccess}
                        onError={handleAddCandidateError}
                        recruiter={recruiter!}
                        styles={styles.addCandidate}
                    />
                </RemoveScroll>
            )}
            {openCVPopup && (
                <RemoveScroll>
                    <PopUpWindow styles={styles.viewCV.popup} open={openCVPopup} toggle={() => setOpenCVPopup(!openCVPopup)} closeCircle={true}>
                        {cvPreviewCandidate && <DocumentViewer document={getCandidateCVUrlByRecruiter(recruiter!.recruiterId, cvPreviewCandidate.cvTranslationText, recruiter!.token)} styles={styles.viewCV.documentViewer}/>}               
                    </PopUpWindow>
                </RemoveScroll>
            )}
            {(!isMobile && displayTabs) && (
                <RemoveScroll>
                    <PopUpWindow styles={styles.popUpTabs} open={!isMobile && displayTabs} toggle={closePopUp} closeCircle={!isMobile}> 
                        {profileLoading ? (
                            <CandidateTabPanelLoader />
                        ) : (
                            <TabPanel 
                                selectedCandidate={profileDetails?.candidate!} 
                                style={styles.popUpContainer} 
                                tabItems={tabItems} 
                                onClose={closePopUp}
                            />
                        )}
                    </PopUpWindow>
                </RemoveScroll>
            )}
            {!isMobile && (
                <PopUpWindow styles={styles.emailContainer} open={!isMobile && showEmailComponent} toggle={closeEmailComponent} closeCircle={!isMobile}>
                    <EmailToCandidate 
                        recipientEmails={recipientEmails} 
                        candidateIds={candidateIds}
                        recruiterId={recruiter!.recruiterId}
                        token={recruiter!.token}
                        style={styles.emailContainer}
                        onClose={closeEmailComponent}
                        onParentAlert={openAlert} 
                    />
                </PopUpWindow>
            )}
            <Alert />
            <Footer/>
        </>
    );
}
